// src/components/CartItem.js
import React from "react";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../services/api";

function CartItem({ item, lang }) {
  const { changeQty, removeFromCart } = useCart();
  const navigate = useNavigate();

  const isOutOfStock = item.stock_qty === 0;
  const isAtMaxStock = item.qty >= item.stock_qty;

 const goToProduct = () => {
  if (!item.slug) return;

  apiRequest("/analytics/track", {
    method: "POST",
    body: JSON.stringify({
      action_type: "view_product",
      entity_type: "product",
      entity_id: item.product_id, // IMPORTANT
    }),
  }).catch(() => {});

  navigate(`/product/${item.slug}`);
};


  return (
    <div
  onClick={goToProduct}
  role="button"
  tabIndex={0}
  className="
    cursor-pointer
    w-full flex gap-4 p-4 
    bg-white border border-[#E6D8D2] rounded-lg
    shadow-sm hover:shadow-[0_0_10px_rgba(0,0,0,0.08)]
    transition-all relative
  "
>
    {isOutOfStock && (
  <div
    className="
      absolute -left-10 top-4
      rotate-[-45deg]
      bg-red-600 text-white
      text-xs font-bold
      px-10 py-1
      shadow-md
      pointer-events-none
    "
  >
    {lang === "EN" ? "OUT OF STOCK" : "نفد المخزون"}
  </div>
)}


      {/* IMAGE */}
      <img
        src={item.image}
        className="w-24 h-24 object-cover rounded-md bg-[#F2EFED]"
        alt={lang === "EN" ? item.nameEN : item.nameAR}
      />

      {/* DETAILS */}
      <div className="flex flex-col flex-1">
        <p className="font-semibold text-[#2E3135] leading-tight pr-6">
  {lang === "EN" ? item.nameEN : item.nameAR}
</p>

{item.public_id && (
  <p className="text-[11px] text-[#9F9087] mt-[2px]">
    {item.public_id}
  </p>
)}

         {/* COLOR DOT + SIZE BADGE */}
           {(item.color || item.size) && (
             <div className="flex items-center gap-3 mt-1">
    
               {/* COLOR DOT */}
               {item.color && (
                 <div
                   className="w-3.5 h-3.5 rounded-full border border-[#D3C5BE]"
                   title={item.color}
                   style={{ backgroundColor: item.color_hex || "#000000" }}
                 />
                        )}       
               {/* SIZE BADGE */}
                        {item.size && (
                 <span
                   className="
                     text-[11px] px-2 py-[2px] 
                     rounded-full border border-[#D3C5BE]
                     text-[#2E3135] font-medium
                   "
                 >
                   {lang === "EN" ? `Size ${item.size}` : `مقاس ${item.size}`}
                </span>
               )}
             </div>
           )}


        <p className="text-black font-bold mt-1">${item.price}</p>
         
         {!isOutOfStock && isAtMaxStock && (
  <p className="text-xs text-red-600 font-medium mt-1">
    {lang === "EN"
      ? `Only ${item.stock_qty} left`
      : `المتبقي ${item.stock_qty} فقط`}
  </p>
)}


        {/* QTY + REMOVE */}
        <div className="flex items-center justify-between mt-4">

          {/* QTY SELECTOR */}
          <div
            className="
              flex items-center  
              border border-[#E6D8D2] rounded-full 
              px-3 py-1 bg-[#F7F3F1]
            "
          >
            <button
  className="text-lg px-2 opacity-70 hover:opacity-100"
  disabled={isOutOfStock}
  onClick={(e) => {
  e.stopPropagation();
  !isOutOfStock && changeQty(item.id, -1);
}}
>
  −
</button>

            <span className={`mx-3 font-medium ${isOutOfStock ? "text-red-500" : ""}`}>
  {item.qty}
</span>

           <button
  className={`text-lg px-2 ${
    isAtMaxStock || isOutOfStock
      ? "opacity-40 cursor-not-allowed"
      : "opacity-70 hover:opacity-100"
  }`}
  disabled={isOutOfStock}
  onClick={(e) => {
  e.stopPropagation();
  !isOutOfStock && !isAtMaxStock && changeQty(item.id, 1);
}}
>
  +
</button>

          </div>

          {/* REMOVE BUTTON */}
          <button
            className="text-xl text-[#A29F9D] hover:text-black transition"
            onClick={(e) => {
  e.stopPropagation();
  removeFromCart(item.id);
}}
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}

export default CartItem;
